import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { getImagePath } from '../../utils/imagePath';

const RALA = () => {
  const [activeImage, setActiveImage] = useState(0);

  const sectionData = {
    name: 'RA Ladies Association (RALA)',
    category: 'Social & Community',
    description: 'Women\'s social and community engagement group.',
    longDescription: 'RALA brings together the women of our community for friendship, empowerment, and service. Through regular social events, charitable activities, and personal development programs, we create lasting bonds and make a positive impact. Join us for coffee mornings, book clubs, charity fundraisers, and more.',
    images: [
      getImagePath('images/bars/rala.jpg'),
      getImagePath('images/bars/rala.jpg'),
      getImagePath('images/bars/rala.jpg')
    ],
    icon: 'fa-female',
    members: '85+ active members',
    coordinator: 'Mrs. Funmi Adebayo',
    schedule: 'Monthly meetings & events',
    level: 'Women Only',
    features: [
      'Monthly Social Gatherings',
      'Charity & Fundraising',
      'Book Club',
      'Wellness Workshops',
      'Networking Events',
      'Community Outreach',
      'Cultural Celebrations',
      'Guest Speakers'
    ],
    facilities: ['Meeting Room', 'Event Space', 'Garden Area', 'Tea Lounge'],
    contact: {
      phone: '+234 905 584 6379',
      email: 'rala@nlngraclub.com',
      extension: '210'
    },
    activities: ['Coffee Mornings', 'Charity Galas', 'Workshops', 'Excursions'],
    causes: ['Women\'s Education', 'Children\'s Welfare', 'Community Development']
  };

  return (
    <div className="section-detail-page">
      {/* Hero Section */}
      <section className="section-detail-hero">
        <div className="hero-background">
          <img src={sectionData.images[0]} alt={sectionData.name} />
          <div className="hero-overlay"></div>
        </div>
        <div className="container">
          <motion.div 
            className="hero-content"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <Link to="/sections" className="back-link">
              <i className="fas fa-arrow-left"></i> Back to Sections
            </Link>
            <span className="section-category">{sectionData.category}</span>
            <h1 className="section-title">{sectionData.name}</h1>
            <p className="section-subtitle">{sectionData.description}</p>
          </motion.div>
        </div>
      </section>

      {/* Section Content */}
      <section className="section-content-section">
        <div className="container">
          <div className="section-grid">
            {/* Left Column - Images */}
            <div className="section-gallery">
              <div className="main-image">
                <img 
                  src={sectionData.images[activeImage]} 
                  alt={sectionData.name} 
                />
              </div>
              <div className="image-thumbnails">
                {sectionData.images.map((img, index) => (
                  <button 
                    key={index} 
                    className={`thumbnail-btn ${activeImage === index ? 'active' : ''}`}
                    onClick={() => setActiveImage(index)}
                  >
                    <img src={img} alt={`${sectionData.name} ${index + 1}`} />
                  </button>
                ))}
              </div>
            </div>

            {/* Right Column - Details */}
            <div className="section-details">
              <div className="detail-section">
                <h2>About {sectionData.name}</h2>
                <p className="section-description">{sectionData.longDescription}</p>
              </div>

              <div className="coach-info">
                <div className="info-card">
                  <i className="fas fa-user-tie"></i>
                  <div>
                    <h4>Coordinator</h4>
                    <p>{sectionData.coordinator}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-users"></i>
                  <div>
                    <h4>Members</h4>
                    <p>{sectionData.members}</p>
                  </div>
                </div>
                <div className="info-card">
                  <i className="fas fa-clock"></i>
                  <div>
                    <h4>Meetings</h4>
                    <p>{sectionData.schedule}</p>
                  </div>
                </div>
              </div>

              <div className="detail-section">
                <h3>Key Features</h3>
                <ul className="features-list">
                  {sectionData.features.map((feature, index) => (
                    <li key={index}>
                      <i className="fas fa-check-circle"></i>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="additional-info">
                <div className="info-row">
                  <span className="info-label">Activities:</span>
                  <span className="info-value">{sectionData.activities.join(' • ')}</span>
                </div>
                <div className="info-row">
                  <span className="info-label">Causes:</span>
                  <span className="info-value">{sectionData.causes.join(' • ')}</span>
                </div>
              </div>

              <div className="action-buttons">
                <Link to="/login" className="btn btn-primary btn-large">
                  <i className="fas fa-handshake"></i> Join RALA
                </Link>
                <Link to="/contact" className="btn btn-outline btn-large">
                  <i className="fas fa-envelope"></i> Upcoming Events
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RALA;